<template>
  <div class="top-presets-wrap">
    <div v-if="title" class="title text-body-m-book">
      {{ title }}
    </div>
    <ui-horizontal-scroll
      v-if="list.length"
      ref="presets"
      class="top-presets"
      :style="style"
    >
      <div ref="presetsList" class="top-presets_list">
        <ui-ui-button
          v-for="(item, index) in props.list"
          :key="index"
          class="top-presets_btn"
          mode="link"
          type="secondary"
          :path="getUrl(item.slug)"
        >
          {{ item.name }}
        </ui-ui-button>
      </div>
      <ui-ui-button-ico
        v-if="showMore"
        icon="down"
        class="show-all_btn"
        :class="{ open: isOpened }"
        mode="button"
        stroke="white"
        size-ico="20"
        @click="onShowMore"
      />
    </ui-horizontal-scroll>
  </div>
</template>
<script setup lang="ts">
import { useShowMore } from '~/composition/useShowMore';

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  title: String,
});

const presets = ref<{ $el: HTMLElement }>();
const presetsList = ref<HTMLElement>();

const { onShowMore, isOpened, showMore, style } = useShowMore(
  presets,
  presetsList,
  0
);

const getUrl = (slug: string) => {
  return slug.includes('?') || slug.includes('#') ? `/${slug}` : `/${slug}/`;
};
</script>

<style scoped lang="scss">
.top-presets {
  overflow-y: hidden;
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  height: auto;
  @include xl-block {
    height: 44px;
  }

  &_list {
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 1 auto;
    margin: 0;
    flex-flow: row nowrap;

    a:not(:last-child) {
      margin-right: 4px;
    }
    @include md-block {
      a:not(:last-child) {
        margin-right: 8px;
      }
    }
    @include xl-block {
      flex-flow: row wrap;
    }

    .top-presets_btn {
      width: auto;

      @include xl-block {
        margin-bottom: 8px;
      }

      &:last-child {
        margin: 0;
      }
    }
  }

  &-wrap {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    flex-direction: column;
    @include xl-block {
      flex-direction: row;
    }

    .title {
      color: $achromatic-disabled;
      display: flex;
      align-items: center;
      margin: 0 12px 8px 0;
      height: auto;
      font-size: 14px;
      line-height: 20px;
      font-weight: 700;

      @include xl-block {
        margin: 0 18px 0 8px;
        height: 44px;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
  .show-all_btn {
    :deep(.button__ico-before) {
      transform: rotate(0deg);
      transition: transform 0.3s ease;
    }
    &.open {
      :deep(.button__ico-before) {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
